import { useEffect, useRef } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    const target = window.location.pathname || "/";
    if (!sid) { window.location.replace(target); return; }
    axios.post(`${API}/auth/session`, { session_id: sid }, { withCredentials: true })
      .catch(() => { /* fall through — user stays signed out */ })
      .finally(() => { window.location.replace(target); });
  }, []);

  return (
    <div style={{ padding: "6rem 1rem", textAlign: "center" }} data-testid="auth-callback">
      <p style={{ fontSize: "1.05rem", color: "#14532D", fontWeight: 600 }}>Signing you in…</p>
    </div>
  );
}
